import client from '../../providers/fetchClient'

export const getSigners = params => client.get('/v3/signers', { params })

export const getSignersById = id => client.get(`/v3/signers/${id}`)

export const getCurrentUserSigner = () => client.get('/v3/signers/me')
